<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="sa-nw-reference-modal"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <span class="font-weight-bold mb-3">
              こちらの内容でCPA 5G SA NW設定を行います。よろしいですか？
            </span>
            <sa-nw-setting-info
              :cpaContractInfo="cpaContractInfo"
              :nwSettingDetail="nwSettingDetail"
              :nwOptions="nwOptions"
              :isUpdateRequiredRed="true"
              :isShowBandwidthInfo="true"
              :isSortUeIpAllocationIpv4List="true"
            />
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">設定</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >キャンセル</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import SaNwSettingInfo from "@/components/cpa5gSa/SaNwSettingInfo.vue";
import type { CpaContract, CpaNwDetail, CpaNwOptions } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaNwDataUpdateConfirm",
  components: { SaNwSettingInfo },
  props: {
    /** CPA契約情報 */
    cpaContractInfo: {
      type: Object as PropType<CpaContract>,
      required: true,
    },
    /** CPA NW 詳細情報 */
    nwSettingDetail: {
      type: Object as PropType<CpaNwDetail>,
      required: true,
    },
    /** CPA特殊項目設定情報 */
    nwOptions: {
      type: Object as PropType<CpaNwOptions>,
      required: true,
    },
  },
});
</script>
